import script from "./WoononListProduct.vue?vue&type=script&lang=ts&setup=true"
export * from "./WoononListProduct.vue?vue&type=script&lang=ts&setup=true"

import "./WoononListProduct.vue?vue&type=style&index=0&id=3584b102&lang=less&scoped=true"

import exportComponent from "/var/build/production/buyers-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3584b102"]])

export default __exports__